import { Component, Input } from '@angular/core';

@Component({
  selector: 'tangram-builder-step',
  templateUrl: './tangram-builder-step.component.html',
  styleUrls: ['./tangram-builder-step.component.scss']
})
export class TangramBuilderStepComponent {
  @Input() stepNumber: number = 1;
  @Input() title: string = '';
  @Input() description: string = '';
  @Input() isActive: boolean = false;
  @Input() isComplete: boolean = false;
}
